export const submitApprovarRequest_actionType = {
    SUBMIT_ACTION_START: "SUBMIT_ACTION_START",
    SUBMIT_ACTION_SUCCESS: 'SUBMIT_ACTION_SUCCESS',
    SUBMIT_ACTION_FAILURE: 'SUBMIT_ACTION_FAILURE',
    APPROVE_OWN_REQUEST_FAILURE: 'APPROVE_OWN_REQUEST_FAILURE'
};